import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const Pokladna = {
	name: NAME,
	apiProvider,
	router,
};
